import { create } from 'zustand';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

// Helper function to transform states into value/label format
const transformStates = (states) => {
  return states.map((state) => ({
    value: state.id,
    label: state.name
  }));
};

const useGetStatesStore = create((set, get) => ({
  states: [],

  fetchStates: async () => {
    if (get().states.length > 0) return; // Prevent unnecessary API calls
    try {
      const response = await makeRequest(HTTP.GET, API_ENDPOINTS.GET_STATES);
      if (response?.data?.success) {
        const transformedStates = transformStates(response.data.data.states);
        set({ states: transformedStates });
      }
    } finally {
    }
  },

  refetchStates: async () => {
    try {
      const response = await makeRequest(HTTP.GET, API_ENDPOINTS.GET_STATES);
      if (response?.data?.success) {
        const transformedStates = transformStates(response.data.data.states);
        set({ states: transformedStates });
      }
    } finally {
    }
  },

  resetStates: () => set({ states: [] })
}));

export default useGetStatesStore;
